<template>
    <div class="container">
        <h1>Group "{{group['name']}}"</h1>
        <b-tabs position="is-centered" class="block" v-model="activeTab">
            <b-tab-item label="Info">
                <div class="container margin_top_1rem has-text-left">
                    <b-field label="Group name">
                        <b-input v-model="name" required placeholder="Enter name for group"></b-input>
                    </b-field>
                    <div class="buttons">
                        <b-button type="is-danger-outlined" @click="handleBack">Back</b-button>
                        <b-button type="is-success" :disabled="!changeRecorded()" @click="handleChange">Change
                        </b-button>
                    </div>
                </div>
            </b-tab-item>
            <b-tab-item :label="groupObjectsTitle">
                <div class="container margin_top_1rem has-text-left">
                    <div v-if="addFormVisible">
                        <b-field label="Choose object type">
                            <b-select v-model="objectTypeId">
                                <option
                                        v-for="ot in optionsForObjectType"
                                        :key="ot.id"
                                        :value="ot.id"
                                >{{ot.name}}
                                </option>
                            </b-select>
                        </b-field>
                        <b-field label="Choose object" v-if="objectTypeId > 0">
                            <b-select v-model="objectId">
                                <option :value="0">choose...</option>
                                <option
                                        v-for="object in availableObjects"
                                        :key="object.id"
                                        :value="object.id"
                                >{{object.name}}
                                </option>
                            </b-select>
                        </b-field>
                        <b-field label="Object alias" v-if="objectId > 0">
                            <b-input v-model="objectAlias"
                                     placeholder="If not set, the object name will be used"></b-input>
                        </b-field>
                        <div class="buttons">
                            <b-button type="is-danger-outlined" @click="handleClickToggleAddForm">Abort</b-button>
                            <b-button type="is-success" @click="handleAddObject" :disabled="!validAddObjectFields()">Add
                                object to group
                            </b-button>
                        </div>
                        <hr/>
                    </div>
                    <b-button type="is-info" v-else @click="handleClickToggleAddForm" class="is-small">Add Object
                    </b-button>
                </div>
                <div class="container has-text-left margin_top_1rem">
                    <b-table
                            v-if="tableData.length > 0"
                            :narrowed="true"
                            :striped="true"
                            :data="tableData"
                    >
                        <template slot-scope="props">
                            <b-table-column field="edit" label="Edit">
                                <div @click="promptChangeAlias(props.row)">
                                    <b-icon type="is-primary" icon="settings" style="cursor: pointer;"></b-icon>
                                </div>
                            </b-table-column>
                            <b-table-column label="Displayed Name" field="name">
                                {{props.row.name}}
                            </b-table-column>
                            <b-table-column label="Object" field="object">
                                <router-link :to="{path: '/configure/objects/' + props.row.object_id}">
                                    {{props.row.object_name}}
                                </router-link>
                            </b-table-column>
                            <b-table-column label="Object Type" field="object_type_name">
                                {{props.row.object_type_name}}
                            </b-table-column>
                            <b-table-column label="Order" field="prio" numeric>
                                <b-icon class="move" @click.native="handleMoveObjectUp(props.row.object_id)"
                                        type="is-primary"
                                        icon="arrow-up" v-if="props.row.allowMoveUp"></b-icon>
                                <b-icon class="move" @click.native="handleMoveObjectDown(props.row.object_id)"
                                        type="is-primary"
                                        icon="arrow-down" v-if="props.row.allowMoveDown"></b-icon>
                            </b-table-column>
                            <b-table-column field="delete" numeric>
                                <div @click="handleDeleteObject(props.row.object_id)">
                                    <b-icon type="is-danger" icon="delete" style="cursor: pointer;"></b-icon>
                                </div>
                            </b-table-column>
                        </template>
                    </b-table>
                </div>
            </b-tab-item>
            <b-tab-item label="Delete">
                <div class="container margin_top_1rem">
                    <b-button type="is-danger" @click="handleDelete">Delete group</b-button>
                </div>
            </b-tab-item>
        </b-tabs>
    </div>
</template>

<script>
  import {mapGetters, mapActions} from 'vuex';
  import BTabs from "buefy/src/components/tabs/Tabs";
  import BTabItem from "buefy/src/components/tabs/TabItem";
  import BField from "buefy/src/components/field/Field";
  import BInput from "buefy/src/components/input/Input";
  import BButton from "buefy/src/components/button/Button";
  import BSelect from "buefy/src/components/select/Select";
  import BTable from "buefy/src/components/table/Table";
  import BTableColumn from "buefy/src/components/table/TableColumn";

  export default {
    name: "screenconfiguregroup",
    components: {
      BTableColumn,
      BTable,
      BSelect,
      BButton,
      BInput,
      BField,
      BTabItem,
      BTabs
    },
    data() {
      return {
        activeTab: 0,
        name: '',
        prio: 0,
        initialName: '',
        initialPrio: 0,
        addFormVisible: false,
        objectTypeId: 0,
        objectId: 0,
        objectAlias: ''
      };
    },
    computed: {
      ...mapGetters('objects', ['groupById', 'objects', 'objectTypes', 'objectsByObjectType']),
      optionsForObjectType() {
        const ret = [
          {
            id: 0,
            name: 'Choose one...'
          }
        ];

        this.objectTypes.forEach(item => {
          ret.push(item);
        });

        return ret;
      },
      availableObjects() {
        const ret = [];
        const list = this.objectsByObjectType(this.objectTypeId);
        list.forEach(item => {
          if (!this.isObjectPartOfGroup(item.id)) {
            ret.push(item);
          }
        });

        return ret;
      },
      group() {
        return this.groupById(this.$route.params.id);
      },
      groupObjectsTitle() {
        return this.group.items.length > 0 ? 'Objects (' + this.group.items.length + ')' : 'Objects';
      },
      tableData() {
        const ret = [];
        let index = 0;
        this.group.items.forEach(item => {
          item['allowMoveUp'] = index > 0;
          item['allowMoveDown'] = index < this.group.items.length - 1;
          ret.push(item);
          index++;
        });
        return ret;
      }
    },
    methods: {
      ...mapActions('objects', ['modifyGroup', 'removeGroup', 'addObjectToGroup', 'removeObjectFromGroup', 'moveObjectInsideGroupUp', 'moveObjectInsideGroupDown', 'modifyAliasForObjectInGroup']),
      isObjectPartOfGroup(objectId) {
        if (this.group && this.group.items) {
          const filtered = this.group.items.filter(item => {
            return parseInt(item.object_id) === parseInt(objectId);
          });

          return filtered && typeof filtered[0] !== 'undefined';
        }

        return false;
      },
      handleClickToggleAddForm() {
        this.objectId = 0;
        this.addFormVisible = !this.addFormVisible;
      },
      changeRecorded() {
        return this.initialName !== this.name || this.initialPrio !== this.prio;
      },
      handleChange() {
        this.modifyGroup({
          id: this.group.id,
          name: this.name,
          prio: this.prio
        });
        this.resetFields();
      },
      handleDelete() {
        if (confirm('Are you sure ?')) {
          this.removeGroup(this.group.id);
          this.handleBack();
        }
      },
      handleBack() {
        this.$router.push('/configure/groups');
      },
      resetFields() {
        this.initialName = this.name;
        this.initialPrio = this.prio;
      },
      handleAddObject() {
        this.addObjectToGroup({
          id: this.group.id,
          objectId: this.objectId,
          alias: this.objectAlias
        });
        this.handleClickToggleAddForm();
      },
      validAddObjectFields() {
        return this.objectId > 0;
      },
      handleDeleteObject(objectId) {
        if (confirm('Are you sure ?')) {
          this.removeObjectFromGroup({
            id: this.group.id,
            objectId: objectId
          });
        }
      },
      handleMoveObjectUp(objectId) {
        this.moveObjectInsideGroupUp({
          id: this.group.id,
          objectId: objectId
        });
      },
      handleMoveObjectDown(objectId) {
        this.moveObjectInsideGroupDown({
          id: this.group.id,
          objectId: objectId
        });
      },
      promptChangeAlias(item) {
        const valueToDisplay = item.name && item.name.length > 0 ? item.name : '';
        this.$buefy.dialog.prompt({
          message: `Alias for "${item.object_name}"...`,
          inputAttrs: {
            placeholder: `ex. ${item.object_name.replace(/_/g, ' ')}`,
            maxlength: 64,
            value: valueToDisplay
          },
          trapFocus: true,
          onConfirm: (value) => {
            this.modifyAliasForObjectInGroup({
              id: this.group.id,
              objectId: item.object_id,
              alias: value.trim()
            });
          }
        });
      }
    },
    mounted() {
      this.name = this.group ? this.group.name : '';
      this.prio = this.group ? parseInt(this.group.prio) : 0;
      this.resetFields();
    }
  }
</script>

<style scoped>
    h1 {
        font-size: 1.5rem;
        font-weight: bold;
        margin-top: 0.75rem;
        margin-bottom: 0.75rem;
    }

    .margin_top_1rem {
        margin-top: 1rem;
    }

    .margin_bottom_1rem {
        margin-bottom: 1rem;
    }

    .group_items {
        display: flex;
        align-items: center;
        justify-content: space-between;
    }

    .move {
        cursor: pointer;
    }
</style>